import React from 'react';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import './App.scss';

import chinaAttacks from './data/china_attacks.json';
import japanAttacks from './data/japan_attacks.json';
import usaAttacks from './data/usa_attacks.json';
import taiwanAttacks from './data/taiwan_attacks.json';
import chinaGdp from './data/china_gdp.json';

import Intro from './Intro';
import BubbleMap from './BubbleMap';
import AttacksOverTime from './AttacksOverTime';
import AttacksByCountry from './AttacksByCountry';
import ProsecutionTime from './ProsecutionTime';
import LocationFrequency from './LocationFrequency';
import ScatterAgeYear from './ScatterAgeYear';
import OccupationStacked from './OccupationStacked';
import Motivation from './Motivation';
import MiddleAgedMen from './MiddleAgedMen';
import DeathPenalty from './DeathPenalty';
import Afterword from './Afterword';

gsap.registerPlugin(ScrollTrigger);


function App() {

  return (
    <div className="App">
      <div style={{height:'90px'}}></div>
      <Intro />
      <div style={{height:'200px'}}></div>

      <AttacksOverTime data={chinaAttacks}/>

      <AttacksByCountry 
        chinaData={chinaAttacks} 
        usaData={usaAttacks} 
        japanData={japanAttacks} 
        taiwanData={taiwanAttacks}/>
      <div style={{height:'200px'}}></div>
 
      <BubbleMap data={chinaAttacks}/>
      <div className='spacerdiv__tall' />

      <LocationFrequency 
        chinaData={chinaAttacks} 
        usaData={usaAttacks} 
        japanData={japanAttacks} 
        taiwanData={taiwanAttacks}/>
      <div className='spacerdiv__tall' />

      <ScatterAgeYear
        chinaData={chinaAttacks} 
        usaData={usaAttacks} 
        japanData={japanAttacks} 
        taiwanData={taiwanAttacks} />

      <div style={{ height:'20vh' }} />
      <MiddleAgedMen data={chinaGdp} />

      <div className='spacerdiv__tall' />
      <Motivation data={chinaAttacks} />
      <div className='spacerdiv__tall' />

      <OccupationStacked data={chinaAttacks} />

      <div style={{height:'200px'}}></div>

      <div className='center-container'>
        <div className='article-body'>
          <p className='subheader'>中国近乎一半的此类案件“查无后文”：</p>
          <h2>掩盖与压制可能带来更多绝望</h2>
          <div className='spacerdiv' />
          <p>歪脑发现，中国大量无差别案件在公开信息上缺乏跟进，有超过40%的案件都无法从公开渠道得知警方调查、起诉或法庭判决等后续内容，在网络上查无后文。</p>
          <p>是官方禁止还是媒体失去了兴趣呢？媒体人李厚辰认为，不是媒体失去兴趣。他认为中国很多城市，一个问题的发生可能都会牵连到更大的问题。导致人的注意力转向背后深层的原因，例如强拆，整个公共部门的失职等。Peidong Sun也在《外交事务》<i>(Foreign Affairs)</i> 杂志<a href='https://www.foreignaffairs.com/china/roots-revenge-against-society-attacks-china' target='_blank'>写道</a>, “公开袭击通常是为了回应压迫（repression），而荒谬的是，（中国）政府通常会以更大的压迫回应他们。” 例如珠海撞人事件中，据境外媒体<a href='https://cn.nytimes.com/china/20241114/china-car-zhuhai-ramming/dual/' target='_blank'>报道</a>，案发后，网络删贴, <a href='https://theinitium.com/zh-hans/article/20241230-mainland-zhuhai-car-attack-aftermath' target='_blank'>禁止</a>记者采访，未举行新闻发布会，民众在体育中心的献花也很快被收走。</p>
          <p>也有一些学者认为，大量媒体报道会对民众造成某种仿效（copycat）。但李厚辰反驳，“媒体的报道越综合、越多角度， 这个故事就越不容易被浪漫化，英雄主义化、悲剧化， 就越不容易模仿。” 歪脑在整理数据观察到，在早些年，还有不少中国调查新闻深入案件，而大约从2020年起，官方蓝底白字的“警情通报”，往往只有几百字，成为中国公众了解此类案件的主要信源。</p>
          <p>社会学家弗里德曼认为，中国很多地方政府官员，当地有某种冲突时，他们的第一反应往往是试图将其隐藏起来，确保上级不知道。弗里德曼说，“遇到一些小问题，如果能以直接、透明和公平的方式处理，这些问题就不会对政府构成威胁，也不会威胁社会稳定，但如果被掩盖和压制，就会让人们感到绝望。”</p>
        </div>
      </div>
      <div className='spacerdiv__tall' />

      <ProsecutionTime />
      
      <div className='spacerdiv__tall' />

      <DeathPenalty 
        chinaData={chinaAttacks} 
        usaData={usaAttacks} 
        japanData={japanAttacks} 
        taiwanData={taiwanAttacks} />

      <div className="spacerdiv__tall" />
      <Afterword />
    </div>
  );
}

export default App;
